import gql from 'graphql-tag';

export const bulkUpdateServiceRequestStatusMutation = gql`
  mutation bulkUpdateServiceRequestStatusMutation(
    $serviceRequestIds: [String!]!
    $status: String!
  ) {
    bulkUpdateServiceRequestStatus(
      serviceRequestIds: $serviceRequestIds
      status: $status
    ) {
      successCount
      failureCount
      failures {
        serviceRequestId
        reason
      }
    }
  }
`;

